module.exports = __webpack_public_path__ + "img/6.fead7c95.png";